import { TemplateFormatterEnum } from "../enum/TemplateFormatters.enum";
import { ITemplateExtendedContext } from "../interfaces/template/templateContext.interface";
import { $t } from "./t";

const Mustache = (() => require("mustache"))();

export function renderTemplate(tempalte: string, input: ITemplateExtendedContext): string {
  return Mustache.render(tempalte, {
    ...input,
    [TemplateFormatterEnum.DDMMYYYY]: function() {
      return (timestamp: string) => {
        const dateString = Mustache.render(timestamp, input).trim();

        return new Date(dateString).toLocaleDateString("de-de", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit"
        });
      };
    },
    [TemplateFormatterEnum.HHMM]: function() {
      return (timestamp: string) => {
        const dateString = Mustache.render(timestamp, input).trim();

        return `${new Date(dateString)
          .getHours()
          .toString()
          .padStart(2, "0")}:${new Date(dateString)
          .getMinutes()
          .toString()
          .padStart(2, "0")}`;
      };
    },
    [TemplateFormatterEnum.BOOLEAN]: function() {
      return (value: boolean) => {
        const booleanString = Mustache.render(value, input).trim();
        if (booleanString === "true" || booleanString === "1") {
          return $t("yes");
        }
        return $t("no");
      };
    },
    [TemplateFormatterEnum.PERCENTAGES]: function() {
      return (value: number) => {
        const percentageString = Mustache.render(value, input).trim();
        try {
          const percentageValue = parseFloat(percentageString);
          if (isNaN(percentageValue)) {
            return `${percentageString} %`;
          }

          return `${percentageValue.toFixed(2).replace(".", ",")} %`;
        } catch (e) {
          return `${percentageString} %`;
        }
      };
    }
  });
}
